/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import socketIOClient from "socket.io-client";
import * as utilServices from '../../../services/utilService'
import Toast from '../toast';
let getMarqueeInterval
let getMarqueeTimeout
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: "",
            marquee: "",
            toastMsg: "",
            toastType: "",
        };
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    async componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            localStorage.clear();
            this.props.history.push("/auth") 
         }
        let marquee = localStorage.getItem("marquee")
        this.setState({ uid: userData.sub, marquee: marquee }, async () => {
            // const socket = !!this.props.socket ? this.props.socket : socketIOClient(ENDPOINT);
            // socket.emit('site_room', userData.sub)
            // socket.on("site_room", data => {
            //     let msg = JSON.parse(data)
            //     if (!!msg.command && msg.command === "NotifyMarqueeUpdated") {
            //         localStorage.setItem("marquee", msg.payload.message)
            //         this.setState({ marquee: msg.payload.message })
            //     }
            //     if (!!msg.command && msg.command === "LOGOUT") {
            //         this.logout()
            //     }
            // })
            // socket.on('disconnect', () => {
            //     socket.emit('site_room', userData.sub)
            // })


            // if (!marquee) {
            //     let marquee = await utilServices.getMarquee()
            //     localStorage.setItem("marquee", marquee.message)
            //     this.setState({ marquee: marquee.message })
            // } else {
            //     getMarqueeTimeout = setTimeout(async () => {
            //         let marquee = await utilServices.getMarquee()
            //         localStorage.setItem("marquee", marquee.message)
            //         this.setState({ marquee: marquee.message })
            //     }, 5000)
            // }
            // getMarqueeInterval = setInterval(async () => {
            //     clearInterval(getMarqueeInterval)
            //     let marquee = await utilServices.getMarquee()
            //     localStorage.setItem("marquee", marquee.message)
            //     this.setState({ marquee: marquee.message })
            // }, 30000)
        })
    }
    componentWillUnmount(){
        clearInterval(getMarqueeInterval)
        clearTimeout(getMarqueeTimeout)
    }
    render() {
        return (
            <>
                {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                <footer className="container-fluid footer">
                    <div className="row">
                        <div className="col">
                            <marquee scrollamount="5" behavior="scroll">
                                <p className="mb-0">
                                    <i className="fa fa-bullhorn mr-2" aria-hidden="true"></i>{this.state.marquee}
                                </p>
                            </marquee>
                        </div>
                    </div>
                </footer>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.16.0/umd/popper.min.js"></script>
                <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"></script>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Footer);